<div class="modal-header">
    <div class="title">
      <!-- <h2 class="modal-title-prefix"><span translate="ODABIRDOKUMENTA.SINGULAR"></span></h2>  -->
      <h2 class="modal-title-prefix"><span>{{NaslovForme}}</span></h2> 
    </div>        
        <!-- <h2 class="modal-title-prefix"><span translate="ODABIRDOKUMENTA.RACUN.PLURAL"></span></h2> -->
         <!-- <h2 routerLink="/fak/knjiznaodobrenja" class="modal-title-prefix"><span translate="ODABIRDOKUMENTA.KZKO.PLURAL"></span></h2>        -->
    <span class="close" (click)="Close()"><span class="fa fa-fw fa-times"></span></span>
  </div>
  <div class="modal-body">
      <div class="row">
          <div class="col-md-12">
              <filter-with-povezan-dokument
                #filter
                (FilterApplied)="FilterApplied($event)">                
              </filter-with-povezan-dokument>
            </div>
      </div>
    <div class="row">
      <div class="col-md-12">
          <yt-fw-default-table
          *ngIf="modelData!=null && modelData.MainList!=null"
          [Config]="Config"
          [Items]="items"
          [TableColumns]="modelData.MainList.TableColumns"      
          [Condensed]="CondensedTable"
          (RefreshDataClicked)="RefreshData()"
          [RowColors]="rowColors"
          #defaultTable
        >
        </yt-fw-default-table>      
      </div>
    </div>
    <div class="row">
        <!-- <div class="col-md-12"> -->
            <label class="col-form-label col-md-8 col-10" style="font-weight : bold"><span translate="ODABIRDOKUMENTA.KREIRAJSTAVKENAOSNOVUODABRANIH.SINGULAR"></span></label>
            <div class="col-md-4 col-2">
              <input
                style="width: 20px;"
                type="checkbox"
                name="chkKreirajStavke"
                class="form-control"
                #chkKreirajStavke
                >                  
            </div>  
        <!-- </div> -->
    </div>
    
    <div class="containter">
    <div class="row">
      <div class="col-md-12">
        <div class="padding: 0.5rem">	
            <span translate="LEGENDA.SINGULAR"></span>
        </div>
        <div class="row col-md-6" *ngFor="let legend of legends">
          <div style="padding: 0.5rem; position: relative;" >
            <div [style.backgroundColor]="legend.color" style="width: 1rem; height: 1rem; position: absolute;"></div>
            <div style="position: relative; left: 1rem; padding-left: 0.5rem; height: 1.25rem; line-height: 1.25 rem; font-size: 0.9rem;"><span translate={{legend.name}}></span></div>
          </div>
        </div>
      </div>
    </div>
  </div>
  </div>
  <div class="modal-footer">
    <button [disabled]="(!IsLocked && numberOfItems == 0) || IsLocked" type="submit" class="btn btn-primary" id="btnSave" (click)="Save()"><span>Sačuvaj</span></button>
    <button type="button" class="btn btn-secondary" id="btnClose" (click)="Close()"><span>Zatvori</span></button>
  </div>
